import { render, staticRenderFns } from "./InfoTextArea.vue?vue&type=template&id=67e4e9c2&scoped=true&"
import script from "./InfoTextArea.vue?vue&type=script&lang=ts&"
export * from "./InfoTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./InfoTextArea.vue?vue&type=style&index=0&id=67e4e9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4e9c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
